import { render, staticRenderFns } from "./InstagramChart.vue?vue&type=template&id=08af19e3"
import script from "./InstagramChart.vue?vue&type=script&lang=js"
export * from "./InstagramChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports